import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type CriticalVulnerabilitiesConfig = typeof CriticalVulnerabilitiesConfig._.Config;

export const CriticalVulnerabilitiesConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.CriticalVulnerabilities,
  configSchema: z.object({
    repositoryNames: z.array(z.string().min(1)).min(1),
  }),
});
